import '@angular/compiler';
import { registerLocaleData } from '@angular/common';
import localeEsPE from '@angular/common/locales/es-PE';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { App } from './app';
import './styles.css';

registerLocaleData(localeEsPE, 'es-PE');

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
